<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <modal-backdrop @click="closeModal()"/>

      <div class="dialog">
        <div class="header" v-if="showHeader">
          <slot name="header"><h2 class="title">{{ title }}</h2></slot>
          <button type="button" class="btn btn-primary -sm text-white" @click="closeModal()">
            {{ textCloseButton }}<ion-icon name="close-outline"></ion-icon>
          </button>
        </div>

        <div class="body">
          <slot name="body"/>
        </div>

        <div class="footer">
          <slot name="footer"/>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import ModalBackdrop from '@/support/components/modal/ModalBackdrop.vue';

export default {
  name: 'Modal',

  props: {
    showHeader: {
      required: false,
      type: Boolean,
      default: true,
    },

    title: {
      required: false,
      type: String,
      default: '',
    },
    textCloseButton: {
      required: false,
      type: String,
      default: 'Fechar ',
    },
  },

  data() {
    return {
      show: false,
    };
  },

  methods: {
    /**
     * Close the modal.
     */
    closeModal() {
      this.show = false;
      document.querySelector('body').classList.remove('overflow-hidden');
    },

    /**
     * Open modal.
     */
    openModal() {
      this.show = true;
      document.querySelector('body').classList.add('overflow-hidden');
    },
  },

  watch: {
    show(show) {
      this.$emit(show ? 'open' : 'close');
    },
  },

  components: {
    ModalBackdrop,
  },
};
</script>

<style lang="scss" scoped>
@import '@scss/settings/_z-index.scss';

.modal {
  overflow-x: hidden;
  overflow-y: auto;
  @apply fixed;
  @apply top-0;
  @apply right-0;
  @apply bottom-0;
  @apply left-0;
  z-index: map-get($zIndex, modalArea);

  > .dialog {
    @apply bg-white;
    @apply relative;
    width: 600px;
    margin: auto;
    @apply flex;
    @apply flex-col;
    @apply rounded;
    z-index: map-get($zIndex, modalDialog);
    top: 50%;
    transform: translateY(-50%);

    @media screen and (max-width: 992px) {
      width: 90%;
    }
  }

  > .dialog .header {
    @apply px-4;
    @apply pt-4;
    @apply pb-2;
    @apply flex;
    @apply items-start;
    @apply justify-between;
  }

  > .dialog .header .title {
    @apply text-secondary-700;
    @apply uppercase;
    @apply text-sm;
    @apply mt-1;
    @apply font-bold;
    letter-spacing: .05em;
  }

  > .dialog .body {
    @apply px-4;
    @apply py-2;
    @apply overflow-auto;
    @apply flex;
    @apply flex-col;
    @apply items-stretch;
  }

  > .dialog .footer {
    @apply px-4;
    @apply pb-4;
    @apply pt-2;
  }
}
</style>
